<section class="creation-form">
      <button *ngIf="!isCreationMode" (click)="onEdit()" [matTooltip]="'repository.addresses.list.add' | translate"
        mat-mini-fab class="action-button" color="primary">
        <mat-icon aria-label="Add">add</mat-icon>
      </button>
      <app-address-edit *ngIf="isCreationMode && !editedId" (editFinished)="onEditFinished()"></app-address-edit>
    </section>

    <mat-form-field class="filterField">
      <mat-label>Filtrer</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Votre filtre (hors type et donneurs d'ordre)" #input>
    </mat-form-field>

    <section class="datatable-container">
      <mat-checkbox
        color="primary"
        [checked]="allListsExpanded"
        (change)="toggleAllLists($event.checked)">
        Tout développer
      </mat-checkbox>
      <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.addresses.list.name' | translate }}
          </th>
          <td mat-cell *matCellDef="let address"> {{ address.name }} </td>
        </ng-container>

        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.addresses.list.code' | translate }}
          </th>
          <td mat-cell *matCellDef="let address"> {{ address.code }} </td>
        </ng-container>

        <ng-container matColumnDef="street">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.addresses.list.street' | translate }}
          </th>
          <td mat-cell *matCellDef="let address"> {{ address.street }} </td>
        </ng-container>

        <ng-container matColumnDef="streetNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.addresses.list.streetNumber' | translate
            }} </th>
          <td mat-cell *matCellDef="let address"> {{ address.streetNumber }} </td>
        </ng-container>

        <ng-container matColumnDef="locality">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.addresses.list.locality' | translate }}
          </th>
          <td mat-cell *matCellDef="let address"> {{ address.locality }} </td>
        </ng-container>

        <ng-container matColumnDef="postalCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.addresses.list.postalCode' | translate
            }} </th>
          <td mat-cell *matCellDef="let address"> {{ address.postalCode }} </td>
        </ng-container>

        <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.addresses.list.phone' | translate }}
          </th>
          <td mat-cell *matCellDef="let address"> {{ address.phone }} </td>
        </ng-container>

        <ng-container matColumnDef="assignement">
          <th mat-header-cell *matHeaderCellDef> {{ 'repository.addresses.list.assignement.title' | translate }} </th>
          <td mat-cell *matCellDef="let address">
            <span *ngIf="address.isSender && address.isReceiver">{{ 'repository.addresses.list.assignement.sender' |
              translate }} et {{ 'repository.addresses.list.assignement.receiver' | translate }}</span>
            <span *ngIf="address.isSender && !address.isReceiver">{{ 'repository.addresses.list.assignement.sender' |
              translate }}</span>
            <span *ngIf="address.isReceiver && !address.isSender">{{ 'repository.addresses.list.assignement.receiver' |
              translate }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="sites">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.addresses.list.site' | translate }}
          </th>
          <td mat-cell *matCellDef="let address">
            <ul>
              <li *ngFor="let site of getVisibleSites(address)">
                {{ site.name }}
                <small *ngIf="site.type === 'addressGroup'" class="group-badge">
                  Groupe
                </small>
              </li>
            </ul>
            <button
              *ngIf="getRemainingSitesCount(address) > 0"
              mat-button
              color="primary"
              class="show-more-sites"
              type="button"
              (click)="toggleSites(address)">
              {{ isSitesExpanded(address) ? 'réduire' : '+ ' + getRemainingSitesCount(address) + ' autres' }}
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="tags">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.addresses.list.tag' | translate }}
          </th>
          <td mat-cell *matCellDef="let step">
            <ul>
              <li *ngFor="let tag of step.tags">"{{tag}}"</li>
            </ul>
          </td>
        </ng-container>

        <ng-container matColumnDef="services">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'repository.addresses.list.services' | translate }}
          </th>
          <td mat-cell *matCellDef="let address">
            <ul>
              <li *ngFor="let service of getVisibleServices(address)">"{{service}}"</li>
            </ul>
            <button
              *ngIf="(address.services || []).length > maxVisibleSites"
              mat-button
              color="primary"
              class="show-more-sites"
              type="button"
              (click)="toggleServices(address)">
              {{ isServicesExpanded(address) ? 'réduire' : '+ ' + ((address.services || []).length - maxVisibleSites) + ' autres' }}
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> {{ 'repository.addresses.list.actions' | translate }} </th>
          <td mat-cell *matCellDef="let address">
            <ng-container *ngIf="address.id !== editedId">
              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
                [matTooltip]="'repository.addresses.list.edit' | translate" (click)="onEdit(address.id)">
                <mat-icon aria-label="Edit">edit</mat-icon>
              </button>
            </ng-container>
            <ng-container>
              <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading"
                [matTooltip]="'repository.addresses.list.delete' | translate" (click)="delete(address.id)">
                <mat-icon aria-label="Delete">delete</mat-icon>
              </button>
            </ng-container>
          </td>
        </ng-container>

        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let address" [attr.colspan]="displayedColumns.length">
            <div *ngIf="address.id === editedId" class="row-edit"
              [@detailExpand]="address.id === editedId ? 'expanded' : 'collapsed'">
              <app-address-edit [address]="address" (editFinished)="onEditFinished()"></app-address-edit>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row"
          [ngClass]="{ 'expanded-row': row.id === editedId }"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[20, 25, 50, 100]" showFirstLastButtons></mat-paginator>
    </section>
<mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="primary"></mat-progress-bar>